const actionTypes = {
    age: {
        INCREMENT: 'AGE::INCREMENT',
        SET: 'AGE::SET',

    },
    counter: {
        INCREMENT: 'COUNTER::INCREMENT',
        DECREMENT: 'COUNTER::DECREMENT',
        DECREMENT1: 'COUNTER::DECREMENT1',
        MULTIPLY: 'COUNTER::MULTIPLY',
        RESET: 'COUNTER::RESET',
    },
    todos: {
        ADD: 'TODOS::ADD',
    },
    user: {
        UPDATE: 'USER::UPDATE',
    },
}

export default actionTypes;